module.exports = __webpack_public_path__ + "static/media/Screenshot 2024-01-02 at 21-26-50 Google Maps KML.a6b37e16.png";